import * as React from 'react';

import { FOfferType, getTermValue } from '@/packages/JsonQuery';

import { SpecialOffers } from '../../../components/advancedFilters/SpecialOffers';
import { useFiltersContext } from '../../../utils/context';
import { useOfferType } from '../../../utils/useOfferType';

export const SpecialOffersContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const offerType = useOfferType();
  const isPromoEnabled = offerType === FOfferType.FlatNew;
  const promo = getTermValue('promo')(jsonQuery);
  const isBlackFriday = getTermValue('is_black_friday')(jsonQuery);
  const isBlackFridayEnabled = false;

  const handleBlackFridayChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setBlackFriday', arguments: [value] });
    },
    [onChange],
  );

  const handlePromoChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setPromo', arguments: [value] });
    },
    [onChange],
  );

  if (!isBlackFridayEnabled && !isPromoEnabled) {
    return null;
  }

  return (
    <SpecialOffers
      isBlackFriday={isBlackFriday}
      isBlackFridayEnabled={isBlackFridayEnabled}
      isPromoEnabled={isPromoEnabled}
      promo={promo}
      onBlackFridayChange={handleBlackFridayChange}
      onPromoChange={handlePromoChange}
    />
  );
};
